module.exports = __webpack_public_path__ + "static/media/сильное-сердце.56429835.jpg";